import React from 'react';

const FilterEmailInput = ({ value, onChange, inputStyles }) => {
    return (
        <div>
            <div className="mt-2">
                <input
                    value={value}
                    onChange={onChange}
                    style={inputStyles}
                    id="email"
                    placeholder=''
                    name="email"
                    type="email"
                    autoComplete="email"
                    required
                    className="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6" />
            </div>
        </div>
    );
};

export default FilterEmailInput;
